/* eslint-disable unicorn/prefer-spread */

import { isNodeContainsIframe } from './utils'

const MutationObserver = window
  ? window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver
  : null

export function observeWatermark(
  parentEl: Element,
  isTargetNode: (node: Node) => boolean,
  callback: (isStyleAttribure?: boolean) => void,
): MutationObserver | null {
  if (!MutationObserver) return null

  const observer = new MutationObserver((mutationRecords: MutationRecord[]) => {
    for (const record of mutationRecords) {
      switch (record.type) {
        case 'attributes': {
          if (isTargetNode(record.target)) {
            callback(record.attributeName === 'style')

            // 跳出循环
            return
          }
          break
        }
        case 'childList': {
          if (Array.from(record.removedNodes).some((removedNode) => isTargetNode(removedNode))) {
            callback()

            return
          }
          break
        }
        default:
      }
    }
  })

  observer.observe(parentEl, {
    attributes: true,
    attributeOldValue: false,
    childList: true,
    subtree: true,
  })

  return observer
}

export function observeIframes(parentEl: Element, callback: () => void): MutationObserver | null {
  if (!MutationObserver) return null

  const observer = new MutationObserver((mutationRecords: MutationRecord[]) => {
    for (const record of mutationRecords) {
      if (record.target.nodeName === 'HEAD') {
        continue
      }

      if (
        record.type === 'childList' &&
        (Array.from(record.addedNodes).some((el) => isNodeContainsIframe(el)) ||
          Array.from(record.removedNodes).some((el) => isNodeContainsIframe(el)))
      ) {
        callback()

        return
      }
    }
  })

  observer.observe(parentEl, {
    attributes: false,
    childList: true,
    subtree: true,
  })

  return observer
}
